<template>
  <div class="rbu-item-adopted-rate-wrapper">
    <div class="rbu-item-adopted-rate-title">
      <label class="mr-8">Rounding</label>
      <v-select
        outlined
        hide-details
        placeholder="Rounding"
        :items="roundingOptions"
        :value="item.rounding"
        @input="onUpdate({ rounding: $event })"
      ></v-select>
    </div>
    <div v-if="containPrevItems" style="margin-top: 32px">
      <label class="mr-8"
        >SoR Item Rate of the Previous Edition: {{ prevItemValue }}</label
      >
    </div>

    <!-- <v-radio-group
      module:value="item.adopted_rate_type"
      row
      @change="onUpdate({ adopted_rate_type: $event })"
    > -->
    <div class="rbu-div-to-radio" style="margin-bottom: 1rem">
      <div
        color="primary"
        value="CALCULATION"
        class="hover-style"
        @click="onUpdate({ adopted_rate_type: 'CALCULATION' })"
      >
        <div
          class="rbu-item-adopted-rate-content"
          :style="
            item.adopted_rate_type === 'CALCULATION'
              ? 'border: 1px solid red'
              : ''
          "
        >
          <div class="rbu-item-adopted-rate-row">
            <div class="rbu-item-adopted-rate-column-1">
              <v-icon
                color="primary"
                v-if="item.adopted_rate_type === 'CALCULATION'"
                >mdi mdi-radiobox-marked</v-icon
              >
              <v-icon v-else> mdi mdi-radiobox-blank </v-icon>
            </div>
            <div class="rbu-item-adopted-rate-column-2 header">
              Calculated Rate
            </div>
            <div class="rbu-item-adopted-rate-column-3 header">
              Compared with Previous Item
            </div>
          </div>
          <div class="rbu-item-adopted-rate-row">
            <div class="rbu-item-adopted-rate-column-1 header">Original</div>
            <div class="rbu-item-adopted-rate-column-2">
              {{ parsedValue || "0" }}
            </div>
            <div class="rbu-item-adopted-rate-column-3">
              {{ changeFromPrevious }}
            </div>
          </div>
          <div class="rbu-item-adopted-rate-row">
            <div class="rbu-item-adopted-rate-column-1 header">Rounded</div>
            <div class="rbu-item-adopted-rate-column-2">
              {{ roundedValue }}
            </div>
            <div class="rbu-item-adopted-rate-column-3">
              {{ roundedChangeFromPrevious }}
            </div>
          </div>
        </div>
      </div>
      <div
        color="primary"
        value="TCEF"
        class="hover-style"
        v-if="item.previous_item"
        @click="onUpdate({ adopted_rate_type: 'TCEF' })"
      >
        <div
          class="rbu-item-adopted-rate-content"
          :style="
            item.adopted_rate_type === 'TCEF' ? 'border: 1px solid red' : ''
          "
        >
          <div class="rbu-item-adopted-rate-row">
            <div class="rbu-item-adopted-rate-column-1">
              <v-icon color="primary" v-if="item.adopted_rate_type === 'TCEF'"
                >mdi mdi-radiobox-marked</v-icon
              >
              <v-icon v-else> mdi mdi-radiobox-blank </v-icon>
            </div>
            <div class="rbu-item-adopted-rate-column-2 header">TCEF</div>
            <div class="rbu-item-adopted-rate-column-3 header">
              <span class="text--primary"
                >{{ tcefPercentage.toFixed(2) }}%</span
              >
            </div>
          </div>
          <div class="rbu-item-adopted-rate-row">
            <div class="rbu-item-adopted-rate-column-1"></div>
            <div class="rbu-item-adopted-rate-column-2 header">
              Calculated Rate
            </div>
            <div class="rbu-item-adopted-rate-column-3 header">
              Compared with Previous Item
            </div>
          </div>
          <div class="rbu-item-adopted-rate-row">
            <div class="rbu-item-adopted-rate-column-1 header">Original</div>
            <div class="rbu-item-adopted-rate-column-2">
              {{ parsedTcefValue }}
            </div>
            <div class="rbu-item-adopted-rate-column-3">
              {{ tcefPercentage.toFixed(2) }}%
            </div>
          </div>
          <div class="rbu-item-adopted-rate-row">
            <div class="rbu-item-adopted-rate-column-1 header">Rounded</div>
            <div class="rbu-item-adopted-rate-column-2">
              {{ roundedParsedTcefValue }}
            </div>
            <div class="rbu-item-adopted-rate-column-3">
              {{ roundedTcefChange }}
            </div>
          </div>
        </div>
      </div>
      <div
        color="primary"
        value="SECTION_FLUCTUATION"
        class="hover-style"
        v-if="item.previous_item"
        @click="onUpdate({ adopted_rate_type: 'SECTION_FLUCTUATION' })"
      >
        <div
          class="rbu-item-adopted-rate-content"
          :style="
            item.adopted_rate_type === 'SECTION_FLUCTUATION'
              ? 'border: 1px solid red'
              : ''
          "
        >
          <div class="rbu-item-adopted-rate-row">
            <div class="rbu-item-adopted-rate-column-1">
              <v-icon
                color="primary"
                v-if="item.adopted_rate_type === 'SECTION_FLUCTUATION'"
                >mdi mdi-radiobox-marked</v-icon
              >
              <v-icon v-else> mdi mdi-radiobox-blank </v-icon>
            </div>
            <div class="rbu-item-adopted-rate-column-2 header">
              Section Fluctuation
            </div>
            <div class="rbu-item-adopted-rate-column-3 header">
              <span class="text--primary">{{
                item.section.fluctuation_value
                  ? `${sectionFluctuation}%`
                  : "N/A"
              }}</span>
            </div>
          </div>
          <div class="rbu-item-adopted-rate-row">
            <div class="rbu-item-adopted-rate-column-1"></div>
            <div class="rbu-item-adopted-rate-column-2 header">
              Calculated Rate
            </div>
            <div class="rbu-item-adopted-rate-column-3 header">
              Compared with Previous Item
            </div>
          </div>
          <div class="rbu-item-adopted-rate-row">
            <div class="rbu-item-adopted-rate-column-1 header">Original</div>
            <div class="rbu-item-adopted-rate-column-2">
              {{ parsedSectionFluctuationValue }}
            </div>
            <div class="rbu-item-adopted-rate-column-3">
              {{ sectionFluctuation.toFixed(2) }}%
            </div>
          </div>
          <div class="rbu-item-adopted-rate-row">
            <div class="rbu-item-adopted-rate-column-1 header">Rounded</div>
            <div class="rbu-item-adopted-rate-column-2">
              {{ roundedParsedSectionFluctuationValue }}
            </div>
            <div class="rbu-item-adopted-rate-column-3">
              {{ roundedSectionFluctuationChange }}
            </div>
          </div>
        </div>
      </div>

      <div
        color="primary"
        value="AI_ESTIMATE"
        class="hide-radio-button"
        v-if="item.previous_item && !hide_ai_estimation"
      >
        <div class="rbu-item-adopted-rate-content">
          <div class="rbu-item-adopted-rate-row">
            <div class="rbu-item-adopted-rate-column-1"></div>
            <div class="rbu-item-adopted-rate-column-2 header">
              AI Estimation Rate
            </div>
            <div class="rbu-item-adopted-rate-column-3 header">
              Compared with Previous Item
            </div>
          </div>
          <div class="rbu-item-adopted-rate-row">
            <div class="rbu-item-adopted-rate-column-1 header">Original</div>
            <div class="rbu-item-adopted-rate-column-2">
              {{ $parseCurrency(ai_est_rate) }}
            </div>
            <div class="rbu-item-adopted-rate-column-3">
              {{ AIESTValueChange }}
            </div>
          </div>
          <div class="rbu-item-adopted-rate-row">
            <div class="rbu-item-adopted-rate-column-1 header">Rounded</div>
            <div class="rbu-item-adopted-rate-column-2">
              {{ roundedAIESTValue }}
            </div>
            <div class="rbu-item-adopted-rate-column-3">
              {{ roundedAIESTValueChange }}
            </div>
          </div>
          <div
            class="rbu-item-adopted-rate-row"
            style="display: flex; justify-content: center; margin-top: 0.5rem"
          >
            <v-btn
              color="primary"
              class="ai_estimation_btn"
              @click="showAIBox"
              style="z-index: 10"
            >
              <v-icon>mdi mdi-auto-fix</v-icon> &nbsp; AI Estimation
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <!-- </v-radio-group> -->
    <v-dialog v-model="dialog" width="auto">
      <div style="background-color: #edebeb; width: 80vw; height: auto">
        <!-- Header -->
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            text-align: center;
            background-color: #a71c16;
            padding: 1rem;
          "
        >
          <div>
            <v-icon style="color: white"> mdi mdi-auto-fix </v-icon>
            &nbsp;&nbsp;
            <span style="font-size: large; color: white; font-weight: 500"
              >AI Estimation</span
            >
          </div>
          <div>
            <v-icon
              style="color: white; cursor: pointer; font-size: 2rem"
              @click="dialog = false"
            >
              mdi mdi-close
            </v-icon>
          </div>
        </div>

        <!-- PROMPT -->
        <div style="padding: 1rem">
          <div style="color: #e93e47; font-weight: 500; margin-bottom: 12px">
            <v-icon style="font-size: 1.3rem; color: #e93e47"
              >mdi mdi-auto-fix</v-icon
            >
            <span style="text-align: center">AI Prompt</span>
          </div>

          <v-textarea
            outlined
            dense
            hide-details
            auto-grow
            no-resize
            style="background-color: white"
            v-model="prompt"
          ></v-textarea>
        </div>

        <!-- RESPONSE -->
        <div style="padding: 1rem">
          <div style="color: #e93e47; font-weight: 500; margin-bottom: 12px">
            <v-icon style="font-size: 1.3rem; color: #e93e47"
              >mdi mdi-auto-fix</v-icon
            >
            <span style="text-align: center">AI Response</span>
          </div>

          <v-textarea
            outlined
            dense
            hide-details
            rows="15"
            style="background-color: white; color: black"
            v-model="ai_response"
            :readonly="true"
          ></v-textarea>
        </div>

        <!-- CONTROL BTN -->
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 1rem;
            padding-bottom: 2rem;
          "
        >
          <v-btn
            color="primary"
            class=""
            @click="process_ai_result"
            :disabled="!ai_prompt_animation_finish"
          >
            <v-icon>mdi mdi-content-save-check-outline</v-icon> &nbsp;
            {{ ok_btn_text }}
          </v-btn>
          <v-btn
            v-if="!ai_loading"
            color="primary"
            class=""
            @click="get_ai_response"
          >
            <v-icon>mdi mdi-refresh</v-icon> &nbsp; Refresh
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <v-divider></v-divider>
  </div>
</template>

<script>
import RbuItemEditor from "@/components/rbu/RbuItemEditor.vue";
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";
import floatingPointFix from "js-floating-point";

export default {
  name: "RbuItemAdoptedRate",
  components: { RbuItemEditor },
  props: {
    item: Object,
  },
  setup(props, { root, emit }) {
    const dialog = ref(false);
    const prompt = ref("");
    const hide_ai_estimation = ref(false);
    const ai_response = ref("");
    const ai_prompt_animation_finish = ref(false);
    const ok_btn_text = ref("Waiting...");
    const ai_est_rate = ref(0);
    const regex = /\[\[([^\\[\]]+)\]\]/g;
    const ai_loading = ref(false);
    const original_radio = ref("");
    const get_ai_prompt = async () => {
      try {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/rbu/ai/get_prompt_hits/",
          params: {},
        });

        if (response.body.success && response.body.prompt) {
          let current_year = props.item.section.edition.edition;

          let prev_price = 0;
          let prev_year = 2000;

          let next_year = new Date().getFullYear() + 1;

          if (!isNaN(Number(current_year))) {
            next_year = Number(current_year) + 1;
          }

          let current_price = 0;
          let prev_prev_item = null;

          if (
            props.item &&
            props.item.previous_item &&
            props.item.previous_item.value
          ) {
            prev_price = props.item.previous_item.value;

            if (
              props.item.previous_item.item_group &&
              props.item.previous_item.item_group.sor &&
              props.item.previous_item.item_group.sor.edition
            ) {
              prev_year = props.item.previous_item.item_group.sor.edition.id;
            }
          }

          if (
            props.item.previous_item &&
            props.item.previous_item.previous_item
          ) {
            prev_prev_item = props.item.previous_item.previous_item;
          }

          current_price = props.item.calculated_rate;
          prompt.value = response.body.prompt.prompt;
          hide_ai_estimation.value = response.body.prompt.enable;
          prompt.value = prompt.value
            .replace("{{price_of_current_edition}}", current_price)
            .replace("{{year_of_current_edition}}", current_year)
            .replace("{{next_year}}", next_year)
            .replace("{{year_of_previous_edition}}", prev_year)
            .replace("{{price_of_previous_edition}}", prev_price)
            .replace("{{target_year}}", next_year);

          if (
            prev_prev_item &&
            prev_prev_item.item_group &&
            prev_prev_item.item_group.sor &&
            prev_prev_item.item_group.sor.edition &&
            prev_prev_item.item_group.sor.edition.latest_version &&
            prev_prev_item.item_group.sor.edition.latest_version.edition &&
            prev_prev_item.value
          ) {
            const prev_prev_item_edition =
              prev_prev_item.item_group.sor.edition.latest_version &&
              prev_prev_item.item_group.sor.edition.latest_version.edition;
            const prev_prev_item_price = prev_prev_item.value;

            prompt.value = prompt.value.replace(
              "{{year_of_edition_before_last}}",
              prev_prev_item_edition,
            );
            prompt.value = prompt.value.replace(
              "{{price_of_edition_before_last}}",
              prev_prev_item_price,
            );
          }
        }
      } catch (e) {
        console.log(e);
      }
    };
    const get_ai_response = async () => {
      try {
        ai_loading.value = true;
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/rbu/ai/get_ai_results/",
          params: {
            prompt: prompt.value,
          },
        });

        if (response.body.success && response.body.ai_result) {
          typeEffect(response.body.ai_result);
        } else {
          ai_loading.value = false;
        }
      } catch (e) {
        console.log(e);
        ai_loading.value = false;
      }
    };

    const showAIBox = async () => {
      dialog.value = true;
      get_ai_response();
    };

    const typeEffect = (text) => {
      ai_response.value = "";
      ok_btn_text.value = "Waiting...";
      ai_prompt_animation_finish.value = false;
      ai_loading.value = true;

      let i = 0;
      const typingSpeed = 1; // Adjust typing speed (milliseconds per character)

      const type = () => {
        if (i < text.length) {
          ai_response.value += text.charAt(i);
          i++;
          setTimeout(type, typingSpeed);
        } else {
          let lastMatch;
          let match;

          // Loop through all matches to get the last one
          while ((match = regex.exec(ai_response.value)) !== null) {
            lastMatch = match[1];
          }
          const lastMatch_temp = lastMatch;
          try {
            lastMatch = floatingPointFix(parseFloat(lastMatch)).toFixed(2);
          } catch (e) {
            lastMatch = lastMatch_temp;
          }
          if (lastMatch && !isNaN(Number(lastMatch))) {
            ok_btn_text.value = "Save " + lastMatch;
            ai_prompt_animation_finish.value = true;
            ai_loading.value = false;
          } else {
            ok_btn_text.value = "Can not find [[result]]... Please try again!";
            ai_loading.value = false;
          }
        }
      };

      type();
    };

    const process_ai_result = () => {
      dialog.value = false;
      try {
        let lastMatch;
        let match;

        // Loop through all matches to get the last one
        while ((match = regex.exec(ai_response.value)) !== null) {
          lastMatch = match[1];
        }
        const lastMatch_temp = lastMatch;
        try {
          lastMatch = floatingPointFix(parseFloat(lastMatch)).toFixed(2);
        } catch (e) {
          lastMatch = lastMatch_temp;
        }
        if (lastMatch && !isNaN(Number(lastMatch))) {
          ai_est_rate.value = lastMatch;
          save_ai_estimation();
        }
      } catch (e) {
        console.log(e);
      } finally {
        dialog.value = false;
      }
    };

    const save_ai_estimation = async () => {
      try {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/rbu/ai/save_prompt_results/",
          params: {
            item_id: props.item.id,
            prompt: prompt.value,
            result: ai_response.value,
            est_rate: ai_est_rate.value,
          },
        });

        if (response.body.success && response.body) {
          // console.log(response);
        }
      } catch (e) {
        console.log(e);
      }
    };
    const roundingOptions = ref([
      { text: "Round to 0.01", value: "0.01" },
      { text: "Round to 0.1", value: "0.10" },
      { text: "Round to 1", value: "1.00" },
      { text: "Round to 10", value: "10.00" },
      { text: "Round to 100", value: "100.00" },
      { text: "Round to 1000", value: "1000.00" },
    ]);

    const parsedValue = computed(() => {
      if (props.item.calculated_rate) {
        return root.$parseCurrency(props.item.calculated_rate);
      }

      return "$0";
    });
    const roundedValue = computed(() => {
      if (props.item.calculated_rate) {
        return root.$parseCurrency(
          props.item.calculated_rate,
          props.item.rounding,
        );
      }

      return "$0";
    });
    const changeFromPrevious = computed(() => {
      if (props.item.previous_item && props.item.calculated_rate) {
        let prev = parseFloat(props.item.previous_item.value);
        let current = parseFloat(props.item.calculated_rate);
        let percentageChange = ((current - prev) / prev) * 100;

        return percentageChange.toFixed(2) + "%";
      }

      return "0%";
    });
    const roundedChangeFromPrevious = computed(() => {
      if (props.item.previous_item && props.item.calculated_rate) {
        let prev = parseFloat(props.item.previous_item.value);
        let current = root.$roundNumber(
          props.item.calculated_rate,
          props.item.rounding,
        );
        let percentageChange = ((current - prev) / prev) * 100;

        return percentageChange.toFixed(2) + "%";
      }

      return "0%";
    });

    // TCEF
    const tcefPercentage = computed(() => {
      if (props.item.section.edition.tcef) {
        return floatingPointFix(parseFloat(props.item.section.edition.tcef));
      }

      return 0;
    });
    const tcefValue = computed(() => {
      if (props.item.previous_item) {
        let prev = parseFloat(props.item.previous_item.value);
        return floatingPointFix(
          (prev * (100 + tcefPercentage.value)) / 100,
        ).toFixed(2);
      }
      return 0;
    });
    const parsedTcefValue = computed(() => {
      return root.$parseCurrency(tcefValue.value);
    });
    const roundedParsedTcefValue = computed(() => {
      return root.$parseCurrency(tcefValue.value, props.item.rounding);
    });
    const roundedAIESTValue = computed(() => {
      return root.$parseCurrency(ai_est_rate.value, props.item.rounding);
    });
    const roundedTcefChange = computed(() => {
      let prev = parseFloat(props.item.previous_item.value);
      let current = root.$roundNumber(tcefValue.value, props.item.rounding);
      let percentageChange = ((current - prev) / prev) * 100;

      return percentageChange.toFixed(2) + "%";
    });
    const sectionFluctuation = computed(() => {
      if (props.item.section.fluctuation_value) {
        return floatingPointFix(
          parseFloat(props.item.section.fluctuation_value),
        );
      }
      return 0;
    });
    const sectionFluctuationValue = computed(() => {
      if (props.item.previous_item) {
        let prev = parseFloat(props.item.previous_item.value);
        return floatingPointFix(
          (prev * (100 + sectionFluctuation.value)) / 100,
        ).toFixed(2);
      }
      return 0;
    });
    const parsedSectionFluctuationValue = computed(() => {
      return root.$parseCurrency(sectionFluctuationValue.value);
    });
    const roundedParsedSectionFluctuationValue = computed(() => {
      return root.$parseCurrency(
        sectionFluctuationValue.value,
        props.item.rounding,
      );
    });
    const roundedSectionFluctuationChange = computed(() => {
      let prev = parseFloat(props.item.previous_item.value);
      let current = root.$roundNumber(
        sectionFluctuationValue.value,
        props.item.rounding,
      );
      let percentageChange = ((current - prev) / prev) * 100;

      return percentageChange.toFixed(2) + "%";
    });

    const roundedAIESTValueChange = computed(() => {
      let prev = parseFloat(props.item.previous_item.value);
      let current = root.$roundNumber(ai_est_rate.value, props.item.rounding);
      let percentageChange = ((current - prev) / prev) * 100;
      return percentageChange.toFixed(2) + "%";
    });

    const AIESTValueChange = computed(() => {
      let prev = parseFloat(props.item.previous_item.value);
      let current = parseFloat(ai_est_rate.value);
      let percentageChange = ((current - prev) / prev) * 100;
      return percentageChange.toFixed(2) + "%";
    });

    const containPrevItems = computed(() => {
      if (props.item.previous_item && props.item.previous_item.value) {
        return true;
      }
      return false;
    });

    const prevItemValue = computed(() => {
      if (props.item.previous_item && props.item.previous_item.value) {
        return root.$parseCurrency(props.item.previous_item.value, "0.01");
      } else {
        return "N/A";
      }
    });

    const onUpdate = function (evt) {
      if (
        ["TCEF", "CALCULATION", "SECTION_FLUCTUATION"].includes(
          evt.adopted_rate_type,
        )
      ) {
        evt["manually_selected_rate"] = true;
      }
      emit("update", evt);
    };

    onMounted(() => {
      if (props.item.ai_est_result && props.item.ai_est_result.ai_est_value) {
        ai_est_rate.value = floatingPointFix(
          parseFloat(props.item.ai_est_result.ai_est_value),
        ).toFixed(2);
      }
      original_radio.value = props.item.adopted_rate_type;
      get_ai_prompt();
    });

    return {
      containPrevItems,
      prevItemValue,
      prompt,
      dialog,
      ai_prompt_animation_finish,
      ok_btn_text,
      get_ai_prompt,
      get_ai_response,
      ai_response,
      ai_est_rate,
      roundedAIESTValue,
      roundedAIESTValueChange,
      AIESTValueChange,
      process_ai_result,
      roundingOptions,
      parsedValue,
      changeFromPrevious,
      roundedValue,
      roundedChangeFromPrevious,
      tcefPercentage,
      parsedTcefValue,
      roundedParsedTcefValue,
      roundedTcefChange,
      sectionFluctuation,
      parsedSectionFluctuationValue,
      roundedParsedSectionFluctuationValue,
      roundedSectionFluctuationChange,
      onUpdate,
      showAIBox,
      ai_loading,
      hide_ai_estimation,
    };
  },
};
</script>

<style lang="less">
.rbu-item-adopted-rate-wrapper {
  margin-top: 16px;

  .rbu-item-adopted-rate-title {
    width: 500px;
    display: flex;
    align-items: center;
  }

  .rbu-div-to-radio {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1rem;

    div {
      width: 500px;
      .rbu-item-adopted-rate-content {
        padding: 16px;
        background-color: rgba(255, 255, 255, 1);
        border-radius: 8px;
        margin-top: 1rem;
        height: 12rem;

        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: center;

        .rbu-item-adopted-rate-row {
          flex: 1 1 0;

          display: flex;
          width: 100%;
          font-weight: bold;
          align-items: center;

          .rbu-item-adopted-rate-column-1 {
            flex: 0 0 100px;
            text-align: center;
          }

          .rbu-item-adopted-rate-column-2 {
            flex: 1 1 0;
            text-align: center;
          }

          .rbu-item-adopted-rate-column-3 {
            flex: 1 1 0;
            text-align: center;
          }

          .header {
            font-weight: initial;
            color: rgba(0, 0, 0, 0.4);
          }

          .text--primary {
            color: var(--v-primary-base) !important;
            font-weight: bold;
          }

          .v-input__slot::before,
          .v-input__slot::after {
            display: none !important;
          }
        }
      }

      &.v-item--active {
        .rbu-item-adopted-rate-content {
          border: solid 2px var(--v-primary-base);
        }
      }
    }
  }
}
</style>

<style lang="scss">
// .hide-radio-button .v-input--selection-controls__input {
//   display: none;
// }
.hover-style {
  cursor: pointer; /* Change cursor to pointer */
}
</style>
